import { useEffect, useMemo, useState } from "react";

import useEvent from "@/hooks/useEvent";

const useRoutesTooltipIdentify = () => {
  const [routesTooltipIdentifyVisible, setRoutesTooltipIdentifyVisible] = useState(() => {
    // return !localStorage.getItem("__RoutesTooltipIdentify__");
    return true;
  });

  const hideRoutesTooltip = useEvent(() => {
    setRoutesTooltipIdentifyVisible(false);
    // localStorage.setItem("__RoutesTooltipIdentify__", "1");
  });

  useEffect(() => {
    window.addEventListener("scroll", hideRoutesTooltip, false);
    window.addEventListener("mousemove", hideRoutesTooltip, false);
    return () => {
      window.removeEventListener("scroll", hideRoutesTooltip);
      window.removeEventListener("mousemove", hideRoutesTooltip);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo(() => {
    return {
      routesTooltipIdentifyVisible,
      hideRoutesTooltip,
    };
  }, [routesTooltipIdentifyVisible, hideRoutesTooltip]);
};

export default useRoutesTooltipIdentify;
